export const PANEL_WIDTH = 296
export const MOBILE_PANEL_HEIGHT = 280
